/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */



import {Component, EventEmitter, Input, Optional, Output, SkipSelf, TemplateRef, ViewChild} from '@angular/core';

import {ButtonInGroupService} from '../providers/buttonInGroup.service';
export class Button {
private _enableService: boolean = false;

     templateRef: TemplateRef<Button>;
/**
 * @param {?} buttonInGroupService
 */
constructor(
public buttonInGroupService: ButtonInGroupService) {}
private _inMenu: boolean = false;
/**
 * @return {?}
 */
get inMenu(): boolean {
        return this._inMenu;
    }
/**
 * @param {?} value
 * @return {?}
 */
set inMenu(value: boolean) {
        value = !!value;
        if (this._inMenu !== value) {
            this._inMenu = value;
            // We check if the service flag is enabled
            // and if the service exists because the service is optional
            if (this._enableService && this.buttonInGroupService) {
                this.buttonInGroupService.updateButtonGroup(this);
            }
        }
    }
private _classNames: string = "btn";
/**
 * @return {?}
 */
get classNames(): string {
        return this._classNames;
    }
/**
 * @param {?} value
 * @return {?}
 */
set classNames(value: string) {
        if (typeof value === "string") {
            const /** @type {?} */ classNames: string[] = value.split(" ");
            if (classNames.indexOf("btn") === -1) {
                classNames.push("btn");
            }
            this._classNames = classNames.join(" ");
        }
    }
private _name: string = null;
/**
 * @return {?}
 */
get name(): string {
        return this._name;
    }
/**
 * @param {?} value
 * @return {?}
 */
set name(value: string) {
        if (typeof value === "string") {
            this._name = value;
        }
    }
private _type: string = null;
/**
 * @return {?}
 */
get type(): string {
        return this._type;
    }
/**
 * @param {?} value
 * @return {?}
 */
set type(value: string) {
        if (typeof value === "string") {
            this._type = value;
        }
    }
private _disabled: any = null;
/**
 * @return {?}
 */
get disabled(): any {
        return this._disabled;
    }
/**
 * @param {?} value
 * @return {?}
 */
set disabled(value: any) {
        if (value !== null && value !== false) {
            this._disabled = "";
        } else {
            this._disabled = null;
        }
    }

     _click: EventEmitter<boolean> = new EventEmitter<boolean>(false);
/**
 * @return {?}
 */
emitClick(): void {
        this._click.emit(true);
    }
/**
 * @return {?}
 */
ngAfterViewInit() {
        this._enableService = true;
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "clr-button",
    template: `
        <ng-template #buttonProjectedRef>
            <button 
                [class]="classNames" 
                (click)="emitClick()"
                [attr.type]="type"
                [attr.name]="name"
                [attr.disabled]="disabled">
                <ng-content></ng-content>
            </button>
        </ng-template>
    `
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ButtonInGroupService, decorators: [{ type: SkipSelf }, { type: Optional }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'templateRef': [{ type: ViewChild, args: ["buttonProjectedRef", ] },],
'inMenu': [{ type: Input, args: ["clrInMenu", ] },],
'classNames': [{ type: Input, args: ["class", ] },],
'name': [{ type: Input, args: ["name", ] },],
'type': [{ type: Input, args: ["type", ] },],
'disabled': [{ type: Input, args: ["disabled", ] },],
'_click': [{ type: Output, args: ["click", ] },],
};
}

function Button_tsickle_Closure_declarations() {
/** @type {?} */
Button.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Button.ctorParameters;
/** @type {?} */
Button.propDecorators;
/** @type {?} */
Button.prototype._enableService;
/** @type {?} */
Button.prototype.templateRef;
/** @type {?} */
Button.prototype._inMenu;
/** @type {?} */
Button.prototype._classNames;
/** @type {?} */
Button.prototype._name;
/** @type {?} */
Button.prototype._type;
/** @type {?} */
Button.prototype._disabled;
/** @type {?} */
Button.prototype._click;
/** @type {?} */
Button.prototype.buttonInGroupService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
